import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgEnvelopeSimple = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 5.25h-21a.875.875 0 0 0-.875.875V21a1.75 1.75 0 0 0 1.75 1.75h19.25a1.75 1.75 0 0 0 1.75-1.75V6.125a.875.875 0 0 0-.875-.875ZM22.25 7 14 14.563 5.75 7h16.5Zm1.375 14H4.375V8.115l9.033 8.28a.875.875 0 0 0 1.184 0l9.033-8.28V21Z" />
  </svg>
);
export default SvgEnvelopeSimple;
